import dayjs from "dayjs"
import { useParams } from "react-router-dom"

// components
import { useGetRequestApprovalRecords } from "api/hooks/requests/requestReviewApis"
import { Panel } from "components-design-system"
import GridTypeA from "components/grids/GridTypeA/GridTypeA"
import { getEsignColDef, getOutcomeColDef } from "components/grids/columnTemplates"

const ApprovalRecords = ({ panelClassName }) => {
  const { requestId } = useParams()
  const { data: records = [] } = useGetRequestApprovalRecords(requestId)

  const columnDefs = [
    {
      headerName: "Date",
      field: "created_at",
      type: "date",
      cellRenderer: "Date",
      filter: "agDateColumnFilter",
      width: 120,
    },
    {
      headerName: "Time",
      field: "created_at",
      cellRenderer: (params) => {
        if (params.value) return dayjs(params.value).format("hh:mm A")
      },
      width: 90,
    },
    {
      headerName: "Name",
      field: "created_by_fullname",
      cellRenderer: "UserFullnameCellRenderer",
      width: 80,
    },
    {
      headerName: "Files",
      field: "docs",
      valueGetter: (params) => {
        const docs = params.data.docs
        if (!docs) return []
        return docs.map((doc) => {
          if (typeof doc === "string") doc = JSON.parse(doc)
          return doc.document_name
        })
      },
      cellRenderer: ({ value }) => {
        console.log("value", value)
        if (!value || value.length === 0) return null
        return value.join(", ")
      },
    },
    getOutcomeColDef(),
    getEsignColDef(),
    {
      headerName: "Comments",
      field: "comments",
      width: 150,
    },
  ]

  return (
    <Panel
      title="APPROVAL HISTORY"
      iconClassName="fas fa-history"
      className={panelClassName}
    >
      <GridTypeA
        columnDefs={columnDefs}
        rowData={records}
      />
    </Panel>
  )
}

export default ApprovalRecords
